import { createActions } from 'redux-actions';
import keyMirror from 'keymirror';

export const constants = keyMirror({
    GET_COMPANY_TAGS_REQUEST: null,
    GET_COMPANY_TAGS_SUCCESS: null,
    GET_COMPANY_TAGS_FAILURE: null,

    FILTER_COMPANY_TAGS_REQUEST: null,
    FILTER_COMPANY_TAGS_SUCCESS: null,
    FILTER_COMPANY_TAGS_FAILURE: null,

    CREATE_TAG_REQUEST: null,
    CREATE_TAG_SUCCESS: null,
    CREATE_TAG_FAILURE: null,
    
    DELETE_TAG_REQUEST: null,
    DELETE_TAG_SUCCESS: null,
    DELETE_TAG_FAILURE: null,
});

export const {
    getCompanyTagsRequest,
    getCompanyTagsSuccess,
    getCompanyTagsFailure,
} = createActions(
    constants.GET_COMPANY_TAGS_REQUEST,
    constants.GET_COMPANY_TAGS_SUCCESS,
    constants.GET_COMPANY_TAGS_FAILURE,
);

export const {
    filterCompanyTagsRequest,
    filterCompanyTagsSuccess,
    filterCompanyTagsFailure,
} = createActions(
    constants.FILTER_COMPANY_TAGS_REQUEST,
    constants.FILTER_COMPANY_TAGS_SUCCESS,
    constants.FILTER_COMPANY_TAGS_FAILURE,
);

export const {
    createTagRequest,
    createTagSuccess,
    createTagFailure,
} = createActions(
    constants.CREATE_TAG_REQUEST,
    constants.CREATE_TAG_SUCCESS,
    constants.CREATE_TAG_FAILURE,
);

export const {
    deleteTagRequest,
    deleteTagSuccess,
    deleteTagFailure,
} = createActions(
    constants.DELETE_TAG_REQUEST,
    constants.DELETE_TAG_SUCCESS,
    constants.DELETE_TAG_FAILURE,
);
